import React from "react";
import { HiOutlineChartBar } from "react-icons/hi";
import { CHART_FIXED_HEIGHT } from "./aiUsageChartUtils";
import { AiChartContentSkeleton } from "./AiCreditsUsageSkeleton";

export const ChartMetricStrip = ({ items = [] }) => {
  if (!items.length) return null;
  return (
    <div className="flex flex-wrap items-center gap-x-4 gap-y-1 border-b border-gray-50 bg-[#ECF0FD]/30 px-5 py-2.5 text-xs">
      {items.map((item, idx) => (
        <React.Fragment key={item.label}>
          {idx > 0 ? <span className="hidden text-gray-300 sm:inline">|</span> : null}
          <span className="text-gray-500">
            {item.label}:{" "}
            <span className="font-semibold text-gray-800">{item.value}</span>
          </span>
        </React.Fragment>
      ))}
    </div>
  );
};

export const ChartWidgetState = ({
  loading,
  error,
  empty,
  emptyTitle,
  emptyHint,
  skeletonVariant = "bar",
  children,
}) => {
  if (loading) {
    return <AiChartContentSkeleton variant={skeletonVariant} />;
  }

  if (error) {
    return (
      <div
        className="flex items-center justify-center px-5 text-center text-sm text-red-600"
        style={{ height: CHART_FIXED_HEIGHT }}
      >
        {error}
      </div>
    );
  }

  if (empty) {
    return (
      <div
        className="flex flex-col items-center justify-center px-5 text-center"
        style={{ height: CHART_FIXED_HEIGHT }}
      >
        <span className="mb-3 flex h-11 w-11 items-center justify-center rounded-full bg-gray-100 text-gray-400">
          <HiOutlineChartBar className="h-5 w-5" />
        </span>
        <p className="text-sm font-medium text-gray-700">{emptyTitle}</p>
        {emptyHint ? (
          <p className="mt-1 max-w-xs text-xs text-gray-400">{emptyHint}</p>
        ) : null}
      </div>
    );
  }

  return children;
};
